<template>
  <!-- footer -->
  <footer class="footer">
    <div class="flex flex_center">
      <div class="row">
        <div class="col-lg-5">
          <p class="title">联系我们</p>
          <p class="phone">86-0771-8060381</p>
          <p class="address">中国广西省南宁市平乐大道10号</p>
          <div class="text_footer">
            <p>Copyright © 2021 cdhtgroup.com Inc.All Rights Reserved.</p>
            <p>
              ICP/IP：桂ICP备08001557号 广西东博国际经贸投资有限公司 版权所有
            </p>
          </div>
        </div>
      </div>
      <div class="submitBox">
        <p class="title">联系我们</p>
        <p class="miaoshu">收到您的申请，我们将尽快与您取得联系</p>
        <div class="flex flex_left flex_warp submitInput">
          <input type="text" placeholder="您的公司" />
          <input type="text" placeholder="您的称呼" />
          <input type="text" placeholder="您的电话" />
          <input type="text" placeholder="您的邮箱" />
          <div class="submitApply text_center">提交申请</div>
        </div>
      </div>
      <div class="qcordBox">
        <img src="" alt="" class="qcord" />
        <p class="text_center">扫一扫关注微信公众号</p>
      </div>
    </div>
  </footer>
  <!-- footer -->
</template>
<style>
.footer {
  max-width: 1920px;
  width: 100%;
  min-width: 1380px;
  height: 210px;
  background-color: rgb(26, 26, 26);
  margin: 0 auto;
  padding: 64px 0 128px 0;
}
.footer > div {
  width: 1380px;
  margin: 0 auto;
}
.row {
  width: 526px;
}
.title {
  font-size: 18px;
  color: #fff;
  font-weight: 700;
}
.phone {
  font-size: 36px;
  color: #cd9a4c;
  font-weight: 700;
  line-height: 2;
}
.address {
  font-size: 14px;
  color: #777;
}
.miaoshu {
  margin-top: 10px;
  font-size: 14px;
  color: #777;
}
.text_footer {
  margin-top: 32px;
}
.text_footer p {
  font-size: 14px;
  color: #777;
  line-height: 28px;
}
.submitBox {
  width: 526px;
}
.submitInput {
  margin-top: 10px;
}
.submitInput input {
  width: 205px;
  height: 34px;
  background-color: rgb(49, 49, 49);
  color: #777;
  padding: 0 16px;
  box-sizing: border-box;
  margin: 10px 10px 0 0;
}
.submitApply {
  width: 205px;
  color: #fff;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  margin-top: 16px;
  background-color: #cd9a4c;
}
.qcordBox {
  width: 220px;
}
.qcordBox img {
  width: 156px;
  height: 156px;
  display: block;
  margin: 15px auto 0;
}
.qcordBox p {
  font-size: 14px;
  color: #fff;
  margin-top: 14px;
}
</style>
<script>
export default {

}
</script>